import { c as _c } from "react/compiler-runtime";
export function ActionButton(t0) {
  const $ = _c(4);
  const {
    label,
    onClick,
    disabled: t1
  } = t0;
  const disabled = t1 === undefined ? false : t1;
  let t2;
  if ($[0] !== disabled || $[1] !== label || $[2] !== onClick) {
    t2 = <button type="button" onClick={onClick} disabled={disabled} className="tw-rounded-lg tw-border tw-border-solid tw-border-iron-700 tw-bg-iron-900 tw-px-4 tw-py-2.5 tw-text-sm tw-font-semibold tw-text-iron-200 tw-transition tw-duration-200 disabled:tw-cursor-not-allowed disabled:tw-opacity-60 desktop-hover:hover:tw-border-iron-600 desktop-hover:hover:tw-bg-iron-800">{label}</button>;
    $[0] = disabled;
    $[1] = label;
    $[2] = onClick;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  return t2;
}
export function DraftChipButton(t0) {
  const $ = _c(6);
  const {
    label,
    onClick,
    disabled: t1,
    active: t2,
    compact: t3,
    isToggle: t4
  } = t0;
  const disabled = t1 === undefined ? false : t1;
  const active = t2 === undefined ? false : t2;
  const compact = t3 === undefined ? false : t3;
  const isToggle = t4 === undefined ? false : t4;
  const stateClasses = active ? "tw-border-primary-400 tw-bg-primary-500/15 tw-text-primary-200 desktop-hover:hover:tw-border-primary-300 desktop-hover:hover:tw-bg-primary-500/20" : "tw-border-iron-700 tw-bg-iron-950 tw-text-iron-200 desktop-hover:hover:tw-border-iron-600 desktop-hover:hover:tw-bg-iron-800";
  const sizeClasses = compact ? "tw-px-2.5 tw-py-1 tw-text-xs" : "tw-px-3 tw-py-1.5 tw-text-xs";
  const t5 = isToggle ? active : undefined;
  const t6 = `tw-rounded-lg tw-border tw-border-solid tw-font-semibold tw-transition tw-duration-200 disabled:tw-cursor-not-allowed disabled:tw-opacity-60 ${sizeClasses} ${stateClasses}`;
  let t7;
  if ($[0] !== disabled || $[1] !== label || $[2] !== onClick || $[3] !== t5 || $[4] !== t6) {
    t7 = <button type="button" onClick={onClick} disabled={disabled} aria-pressed={t5} className={t6}>{label}</button>;
    $[0] = disabled;
    $[1] = label;
    $[2] = onClick;
    $[3] = t5;
    $[4] = t6;
    $[5] = t7;
  } else {
    t7 = $[5];
  }
  return t7;
}